import React from 'react';
import PropTypes from 'prop-types';

import SelectableRow from 'components/selectable_record_table/selectable_row';

export default function TaskRow({ canRequirePlaybookTasks, selectedTaskIds, task, onSelectTask }) {
  return (
    <SelectableRow
      selected={selectedTaskIds.indexOf(task.id) !== -1}
      onChange={() => onSelectTask(task)}
    >
      <td className="name">{task.name}</td>
      {canRequirePlaybookTasks && <td>{task.required ? 'Yes' : 'No'}</td>}
      <td>{task.assigneeType == 'primary_broker' ? 'Primary broker' : task.assignee?.name}</td>
      <td>{task.dueDate}</td>
    </SelectableRow>
  );
}

TaskRow.propTypes = {
  canRequirePlaybookTasks: PropTypes.bool,
  selectedTaskIds: PropTypes.array.isRequired,
  task: PropTypes.shape({
    assigneeType: PropTypes.string,
    assignee: PropTypes.shape({
      name: PropTypes.string
    }),
    dueDate: PropTypes.string,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onSelectTask: PropTypes.func.isRequired
};
